export default __webpack_public_path__ + "static/media/yr-microphone.2eb23aef.svg";